



































































































































































































































































import _ from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'
import {DateRange} from 'vuetify-daterange-picker'
import UserList from '@/modules/user/components/UserList.vue'
import UserSelect from '@/modules/user/components/UserSelect.vue'
import DepartmentSelect from '@/modules/reservation/components/DepartamentSelect.vue'
import {RawLocation, Route} from 'vue-router'
import {Colors, notify} from '@/modules/core/notification'
import Period from 'date-period'
import {Action, State} from 'vuex-class'
import Reservation, {ReservationPaymentMethod} from '@/modules/reservation/model/Reservation'
import ServiceSelect from '@/modules/reservation/components/ServiceSelect.vue'
import DepartmentType from '@/modules/reservation/model/DepartmenType'
import EventSelect from '@/modules/reservation/components/EventSelect.vue'
import {ReservationDateRange as DateAvailability} from '@/modules/reservation/api'
import DepartmentTypeSelect from '@/modules/reservation/components/DepartmentTypeSelect.vue'
import DepartmentInlineSelect from '@/modules/reservation/components/DepartmentInlineSelect.vue'
import Department from '@/modules/reservation/model/Department'
import {Prop, Watch} from 'vue-property-decorator'
import PrintReservation from "@/modules/reservation/components/PrintReservation.vue";

export interface ReservationDateRange {
    text: string,
    start: Date
    end: Date
    index: number
    isNextDay: boolean,
    availabilityRange: DateAvailability,
    available: boolean,
    disabled: boolean
}

/**
 * Pantalla de edición de una reserva
 *
 * Muestra al usuario la información de una reserva y permite modificar su información.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        PrintReservation,
        DepartmentInlineSelect,
        DepartmentTypeSelect,
        EventSelect,
        ServiceSelect,
        UserSelect,
        UserList,
        DateRange,
        DepartmentSelect,
    },
})
export default class ReservationDetail extends Vue {
    public $refs: Vue['$refs'] & {
        form: {
            validate (): boolean,
            update (field: string, value: any): void,
        },
    }

    /**
     * Volver a
     *
     * Especifica la ruta a la que la aplicación navegará cuando el usuario cierre la
     * pantalla del detalle.
     */
    @Prop({type: [String, Object], default: null})
    public backTo: string | RawLocation | null


    /**
     * Reserva seleccionada por el usuario, la que se esta mostrando en pantalla
     *
     * @var { Reservation }
     */
    @State(state => state.reservation.currentReservation)
    public reservation: Reservation

    /**
     * Disponibilidad de fechas
     *
     * Cuando el usuario selecciona un departamento y día la aplicación calcula la lista
     * con las horas para dicho departamento indicando si cada hora se encuentra
     * disponible o ya ha sido ocupada.
     */
    @State(state => state.reservation.reservationDatesAvailability)
    public datesAvailability: Array<{ [key: string]: boolean }>

    /**
     * Precio estimado de reserva
     *
     * Cuando el usuario selecciona departamento, fecha y servicios la aplicación
     * calcula el precio que tendrá la reserva en función de los parámetros
     *
     * @var { boolean  }
     */
    @State(state => state.reservation.estimatedReservationPrice)
    public estimatedReservationPrice: boolean

    /**
     * Guardar reserva
     *
     * Acción del store que guarda los cambios de la reserva que se encuentra en edición
     * por el usuario. Si la reserva es nueva será actualizada, si no existe
     * se creará una nueva
     *
     * @var { Function }
     */
    @Action('reservation/saveReservation')
    public saveReservation: () => Promise<void>

    @Action('reservation/loadReservationDatesAvailability')
    public loadReservationDatesAvailability: (date: DateAvailability[]) => Array<{ [key: string]: boolean }>

    /**
     * Controla la visibilidad de la pantalla para la selección de usuario
     */
    public userSelect = false

    /**
     * Controla la visibilidad de la pantalla para la selección del departamento
     */
    public departmentSelect = false
    public currentUserListPage = 1
    public starDate = null
    public endDate = null
    public loading = false
    public saveConfirm = false
    public valid = false
    public saving = false
    public hoursRange: ReservationDateRange[] = []
    public calculatingHoursRange = false
    public loadingPrice = false
    public paymentMethods = [
        {
            key: ReservationPaymentMethod.Card,
            text: 'Pago con tarjeta de crédito',
            icon: 'mdi-credit-card-outline',
        },
        {
            key: ReservationPaymentMethod.Cash,
            text: 'Pago en efectivo',
            icon: 'mdi-cash',
        },
    ]

    @Watch('$route', {immediate: true})
    public watchRoute (route: Route) {
        this.loadReservation(route)
    }

    public get isNew () {
        return this.reservation.isNew
    }

    public get rules () {
        return {
            department: [
                (v: string) => !!this.reservation.department.id || 'No has seleccionado departamento',
            ],
            user: [
                (v: string) => !!this.reservation.user.id || 'No has seleccionado usuario',
            ],
        }
    }

    public get canSave (): boolean {
        return this.valid
    }

    /**
     * Seleccionar departamento
     *
     * Método invocado cuando el usuario selecciona un departamento desde el componente
     * DepartmentSelect.
     *
     * Reinicia la última hora seleccionada por el usuario y recalcula el precio
     * de la reserva.
     *
     * @see DepartmentSelect
     * @param { Department } department Departamento seleccionado por el usuario
     */
    public async selectDepartment (department: Department) {
        this.$refs.form.update('department', department)
        // Oculta la pantalla de selección del departamento
        this.departmentSelect = false
        await this.calculateHoursRange()
        await this.calculatePrice()
        this.currentTimeRange = null
    }

    /**
     * Fecha (Día, Mes y Año) seleccionada por el usuario
     */
    public get currentReservationDate () {
        return moment(this.reservation.dateStart).format('YYYY-MM-DD')
    }

    public set currentReservationDate (format: string) {
        const setDate = (format: string, time: Date) => {
            const date = moment(format, 'YYYY-MM-DD')

            return moment(time).set({
                date: date.date(),
                year: date.year(),
                month: date.month(),
            }).toDate()
        }

        this.$refs.form.update('dateStart', setDate(format, this.reservation.dateStart))
        this.$refs.form.update('dateEnd', setDate(format, this.reservation.dateEnd))

        this.calculateHoursRange()
        this.calculatePrice()
    }

    /**
     * Rango de horas seleccionado por el usuario, el cual define la duración
     * de la reserva
     */
    public currentTimeRange: ReservationDateRange | null = null


    /**
     * Tipo del departamento para la reserva
     */
    public get departmentType (): DepartmentType | null {
        return _.get(this.reservation, 'department.type', null)
    }

    // @Watch('currentTimeRange')
    // public onReservationDateChange (range: ReservationDateRange) {
    //     this.$refs.form.update('dateStart', range.start)
    //     this.$refs.form.update('dateEnd', range.end)
    // }

    /**
     * Vuelve a la lista de reservas
     */
    public goToList () {
        const location = this.backTo || {name: 'reservations.reservation-list'}
        this.$router.push(location)
    }

    public get timeRangeFormat (): string {
        const f = (d: Date) => moment(d).format('HH:mm')

        return `${f(this.reservation.dateStart)} - ${f(this.reservation.dateEnd)}`
    }

    public async selectRange (range: ReservationDateRange) {
        if (!range.available) {
            notify('La hora no esta disponible', Colors.Error)
            this.currentTimeRange = null

            return
        }

        // Registran en la reserva las fecha de inicio y final
        this.$refs.form.update('dateStart', range.start)
        this.$refs.form.update('dateEnd', range.end)

        this.currentTimeRange = range
        await this.calculatePrice()
    }

    /**
     * Rango de horas
     *
     * Genera una lista de horas que serán mostradas en el selector de hora de
     * la reserva
     */
    public async calculateHoursRange () {
        this.calculatingHoursRange = true
        // El departamento no posee fecha de apertura o cierre, no se puede generar el
        // rango de horas
        if (
            this.reservation.department.isNew
            || !this.reservation.department.closingTime
            || !this.reservation.department.openingTime
            ) {
            this.calculatingHoursRange = false

            return []
        }

        // Retorna una fecha con el tiempo del formato
        const setTime = (date: Date, format: string, forceNextDay = false) => {
            const time = moment(format, 'HH:mm')
            // Comprueba si es necesario añadir un día mas a la fecha
            const nextDay = (
                forceNextDay
                && (time.hour() === date.getHours())
                    ? time.minutes() < date.getMinutes()
                    : time.hours() < date.getHours()
            )

            const m = moment(date).set({hours: time.hours(), minutes: time.minutes()})

            return (nextDay ? m.add(1, 'day') : m).toDate()
        }

        // La fecha seleccionada por el usuario o el día de hoy si todavía no ha seleccionado
        // ninguna
        const date = this.currentReservationDate
            ? moment(this.currentReservationDate, 'YYYY-MM-DD').toDate()
            : new Date()

        const openingTime = setTime(date, this.reservation.department.openingTime)
        const closingTime = setTime(openingTime, this.reservation.department.closingTime, true)

        const period = Period({
            start: openingTime,
            end: closingTime,
            duration: `PT${this.reservation.department.duration}S`,
        })

        const now = Date.now()
        const hours = period.toArray().filter(hour => {
            return moment(hour).isAfter(now)
        })

        const firstHour = hours[0]
        const ranges: ReservationDateRange[] = hours.map((start, index, period) => {
            const end = period[index + 1] || closingTime
            const format = (date: Date) => moment(date).format('HH:mm')

            const isNextDay = start.getDate() > firstHour.getDate()

            return {
                text: `de ${format(start)} a ${format(end)}${isNextDay ? ' del día siguiente' : ''}`,
                start,
                end,
                index,
                isNextDay,
                availabilityRange: new DateAvailability(start, end),
                available: false,
                disabled: false,
            }
        })

        await this.loadReservationDatesAvailability(ranges.map(r => r.availabilityRange))

        ranges.forEach((range: ReservationDateRange) => {
            range.available = _.get(this.datesAvailability, range.availabilityRange.key, false)
            range.disabled = !range.available
        })

        this.calculatingHoursRange = false
        this.hoursRange = ranges
    }

    /**
     * Con la información de la ruta el componente carga una reserva desde el
     * servidor o inserta una nueva en el estado de la aplicación
     * para que el usuario pueda editarla y crearla
     *
     * @param route
     */
    public async loadReservation (route: Route) {
        this.loading = true
        let id: string | number = this.$route.params['id']

        // El usuario ha solicitado comenzar a crear un nuevo departamento
        if (id === 'nueva') {
            await this.$store.dispatch('reservation/loadNewReservation')
            this.loading = false

            return
        }

        id = parseInt(id, 10)
        if (!id || isNaN(id)) {
            notify('El id de departamento no es válido', Colors.Error)
            await this.$router.push({name: 'dashboard'})
            this.loading = false

            return
        }

        try {
            await this.$store.dispatch('reservation/loadReservation', id)
        } catch (e) {
            notify(e.message, Colors.Error)
            await this.$router.push({name: 'reservations.reservation-list'})
        }

        this.loading = false
    }

    /**
     * Calcula el precio de la reserva
     */
    public async calculatePrice () {
        if (this.reservation.department.isNew || !this.currentTimeRange) {
            return
        }

        this.loadingPrice = true
        await this.$store.dispatch('reservation/calculateReservationPrice')

        this.loadingPrice = false
    }

    /**
     * Actualiza la reserva
     */
    public async save () {
        this.saving = true
        try {
            await this.saveReservation()
        } catch (e) {
            notify(`Se ha producido un error: ${e.message}`)
        }

        this.saving = false
        this.saveConfirm = false
    }

    /**
     * Captura cualquier error lanzado por el componente y notifica al usuario con
     * el mensaje
     *
     * @param error
     */
    public errorCaptured (error: Error) {
        this.loading = false
        this.loadingPrice = false

        notify(error.message, Colors.Error)
    }
}
